import React from 'react';
import { BasePage } from '@sm/webassets';

import SEO from '~pricing/components/SEO';
import useScript from '~pricing/hooks/useScripts';
import { EXTERNAL_SCRIPTS } from '~pricing/lib/constants';

export default function Layout({ children }: { children: React.ReactElement }): JSX.Element {
  useScript(EXTERNAL_SCRIPTS);

  return (
    <SEO>
      <style type="text/css">{`
          body {
            overflow-x: hidden;
          }
        `}</style>
      <BasePage pageId="Pricing Summary" legacyWeb="billweb" sticky={false}>
        <main>{children}</main>
      </BasePage>
    </SEO>
  );
}
